import checkmateApi from "../axios/checkmateApi"
import { ITenant } from "../slices/tenantSlice";

export const getTenantList = async () => {
    return checkmateApi({
        method: 'GET',
        url: 'tenants'
    });
}

export const getTenantDetails = async (tenantId: string) => {
    return checkmateApi({
        method: 'GET',
        url: `tenants/${tenantId}`
    });
}

export const createTenant = async (tenant: ITenant) => {
    return checkmateApi({
        method: 'POST',
        url: 'tenants',
        data: tenant
    });
}

export const updateTenant = async (tenant: ITenant) => {
    return checkmateApi({
        method: 'PUT',
        url: `tenants`,
        data: tenant
    });
}

export const deleteTenant = async (id: string) => {
    return checkmateApi({
        method: 'DELETE',
        url: `tenants/${id}`
    });
}
